<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="dashboardMain">
        <div class="top_header">
            <div class="title">
                <div class="label" (click)="changeOrder()" style="cursor: pointer;line-height  : 35px;">
                    {{'ORDER_DASHBOARD.myorders' | translate}}
                </div>
                <div class="label" style="margin-left: 20px;cursor: pointer;line-height  : 35px;"
                    (click)="changeOrder()">
                    {{'ORDER_DASHBOARD.flash_orders' | translate}}
                </div>
                <div class="label"
                    style="margin-left: 20px;cursor: pointer;line-height  : 35px; border-bottom: solid 2px #631D50;">
                    {{'LTL' | translate}}
                </div>

            </div>
            <!-- <div style=" display: flex; width: 127%; ">
                <div class="item title">
                    <div class="label" *ngIf="!selectedStatus.is_deleted">
                        {{'DASHBOARD.myOrders' | translate}}
                    </div>
                </div>
                <div class="btn_section">
                    <div class="upload_btn" (click)="openBulkLRUpload();">
                            {{'DASHBOARD.bulkLRUpload' | translate}}
                        </div>
                    <div class="upload_btn" (click)="getOrders();">
                        <img src="assets/refresh-icon.svg" alt="">
                    </div>
                </div>
            </div> -->
        </div>
        <div class="bottom_header">
            <div class="filter_sec">
                <div class="item" (click)="openFilterDialog()">
                    <div class="advance_search">
                        {{'DASHBOARD.advance' | translate}}
                        <div class="filtericon">
                            <img src="assets/filter-icon.svg" alt="">

                        </div>
                    </div>
                </div>
                <div class="item">
                    <div style="cursor: pointer;" (click)="openReportDialog()">
                        <img src="assets/download-icon-new.svg" alt="">
                    </div>
                    <div class="upload_btn" (click)="getOrders();" style=" padding-left: 16px; cursor: pointer;">
                        <img src="assets/refresh-icon.svg" alt="">
                    </div>
                </div>
            </div>

        </div>


        <div class="filter" [@filterFade]="dashboardFilterChips.length ? 'open' : 'closed'">
            <div class="filterChipsMain">
                <div class="label">{{'DASHBOARD.filter' | translate}}</div>
                <div class="filterChips">
                    <mat-chip-list #chipList aria-orientation="vertical">
                        <mat-chip *ngFor="let filter of dashboardFilterChips; let i = index;" [selectable]="true"
                            [removable]="true" (removed)="removeChip(filter, i)">
                            {{filter.label}} : {{filter.name}}
                            <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                </div>
            </div>

        </div>
        <div class="chips_sec" *ngIf="AdvacnceFilterList && AdvacnceFilterList.length">
            <span class="total_count">{{totalOrders}} result for :</span>

            <div *ngFor="let item of AdvacnceFilterList">
                <span class="search_heading"> {{item.name}} :</span>
                <span class="chip_gap">
                    <mat-chip (removed)="remove(item)"> {{item.value}}<button matChipRemove class="chip_btn">
                            <mat-icon class="close_chip">close</mat-icon>
                        </button></mat-chip>
                </span>
            </div>
            <div class="clear_all" (click)="clear();submitSearch();">Clear All</div>
        </div>
        <div class="note_text">
            <span style="color: #E64F4F;"> <b>{{'DASHBOARD.note' | translate}}</b> : </span>
            <span>{{'DASHBOARD.noteText' | translate}}</span>
        </div>
        <div class="ordersection">

            <div>
                <div class="load">
                    <table mat-table *ngIf="dataSource && dataSource.filteredData.length ;else noOrders"
                        [dataSource]="dataSource" matSort (matSortChange)="sortOrderData($event)" class="loadTable">

                        <ng-container matColumnDef="order">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                                {{'DASHBOARD.order' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div style="display: flex; flex-direction: row;justify-content: center;">
                                    <div>
                                        {{element.order}}
                                    </div>
                                    <div>
                                        <img *ngIf="element.comments" matTooltipClass="comments-tooltip"
                                            src="assets/Comment.svg" alt="" height="18px"
                                            matTooltip="{{element.comments}}" matTooltipPosition="after">
                                    </div>
                                </div>
                                <div>
                                    <p style="font-size:9px">{{element.shipmentDate}}</p>
                                </div>
                                <div
                                    style="text-align: left;padding-left: 25px;font-size: 13px;color: #71747A;font-family:'Inter';">
                                    <span>
                                        <img *ngIf="!element.epod_approved" src="assets/close-icon.svg" alt="">
                                        <img *ngIf="element.epod_approved" src="assets/check-icon.svg" alt="">
                                    </span>
                                    <span style="padding-left:3px;">Epod</span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="pickupDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader"
                                style="width: 160px;">
                                {{'DASHBOARD.pickupDate' | translate}}

                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 100px; word-wrap: break-word;">
                                {{element.pickDate}}
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="from">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                                {{'DASHBOARD.from' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngFor="let pick of element.from; let i=index; let onlyFirst = first"
                                    class="pdSpan">
                                    <strong class="pick">P{{i+1}}</strong> - {{(pick.loc_id && pick.loc_id.name) ?
                                    pick.loc_id.name : ''}}
                                    - {{ (pick.loc_id && pick.loc_id.city) ? pick.loc_id.city : ''}} <br>

                                    <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="to">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                                {{'DASHBOARD.to' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngFor="let delivery of element.to; let i=index" class="pdSpan">
                                    <b class="drop">D{{i+1}}</b> - {{delivery.loc_id.name}} -
                                    {{delivery.loc_id.city}}<br>
                                    <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
                                </span>
                                <span *ngIf="element.consigneeName">{{element.consigneeName}}</span>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="allocation">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                                {{'DASHBOARD.status' | translate}}

                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div>
                                    <div style="display: flex; align-items: center;justify-content: center;">

                                        {{element.status}}
                                    </div>

                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="AWBNumbers">
                            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 50px;">
                                {{'DASHBOARD.AWBNumbers' | translate}}

                            </th>

                            <td mat-cell *matCellDef="let element">
                                <span>{{element.ref_numbers}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="invoiceNumber">
                            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 50px;">
                                {{'Invoice #' | translate}}

                            </th>

                            <td mat-cell *matCellDef="let element">
                                <span>{{element.invoice_no}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cases">
                            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 50px;"> Cases </th>

                            <td mat-cell *matCellDef="let element">
                                {{element.no_of_packages}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="verificationDate_Status">
                            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 50px;">Verification
                                Date & Status
                            </th>

                            <td mat-cell *matCellDef="let element" style="width: 150px;">
                                {{ element.verification_date ? timeService.toShortDateTime(element.verification_date) :
                                '--'}}<br>
                                <span *ngIf="element.epod_approved"
                                    style="color:#18be8a">{{element.verification_status}}</span>
                                <span *ngIf="!element.epod_approved"
                                    style="color:#d60023">{{element.verification_status}}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="EpodReceivedDate">
                            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 50px;">Epod
                                Received Date </th>

                            <td mat-cell *matCellDef="let element" style="width: 150px;">{{element.EpodReceivedDate }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="epod">
                            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 100px;">
                                {{'DASHBOARD.epod' |
                                translate}} </th>
                            <td mat-cell *matCellDef="let element">
                                <a *ngIf="element.epod" [href]="element.epod" target="_blank" download
                                    (click)="$event.stopPropagation()">

                                    <span class="material-icons" *ngIf="element.epodType!='pdf'">
                                        image
                                    </span>
                                    <span *ngIf="element.epodType=='pdf'">
                                        <img src="assets/PDF-icon.svg" alt="">
                                    </span>
                                </a>
                                <span *ngIf="!element.epod">--</span>
                            </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="organization">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">

                                {{'DASHBOARD.serviceProvider' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.service_providers}} </td>
                        </ng-container> -->
                        <ng-container matColumnDef="reason">
                            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'DELETE_ORDERS.reason' |
                                translate}} </th>
                            <td mat-cell *matCellDef="let element" style="
                                max-width: 100px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;" title="{{element.delete_reason}}">
                                {{element.delete_reason}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 20px;">
                                {{'DASHBOARD.action' |
                                translate}} </th>
                            <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation();">
                                <div class="action_item">
                                    <mat-icon class="more-icon"
                                        [ngClass]="{'more_icon_disable': element.is_disabled === true}"
                                        [matMenuTriggerFor]="actions">
                                        more_vert</mat-icon>
                                </div>
                                <mat-menu #actions="matMenu">
                                    <button mat-menu-item
                                        (click)="selectedStatus.is_deleted == false ? viewOrderDetails(element) : ''">
                                        <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-view.svg"
                                            [ngClass]="{action: showStatusTab==0, actionComp: showStatusTab==1}" alt="">
                                        {{'DASHBOARD.view' | translate}}
                                    </button>
                                    <button mat-menu-item (click)="openUploadDocs(element);" *ngIf="!element.epod">
                                        <img style="width: 16px;position: relative;top: 3px;"
                                            src="assets/upload-file.svg"
                                            [ngClass]="{action: showStatusTab==0, actionComp: showStatusTab==1}" alt="">
                                        {{'Upload Epod' | translate}}
                                        <input #epod class="form-input" id="epods"
                                            accept="image/jpeg, .pdf, image/png, image/jpg"
                                            (change)="fileChanged($event, 'epod')" type="file" hidden />
                                    </button>
                                    <button mat-menu-item (click)="showPreview(element);" *ngIf="element.epod">
                                        <img style="width: 16px;position: relative;top: 3px;"
                                            src="assets/upload-file.svg"
                                            [ngClass]="{action: showStatusTab==0, actionComp: showStatusTab==1}" alt="">
                                        {{'DASHBOARD.viewEpod' | translate}}
                                        <input #epod class="form-input" id="epods" accept="image/*, .pdf"
                                            (change)="fileChanged($event, 'epod')" type="file" hidden />
                                    </button>
                                    <button mat-menu-item (click)="deleteEpod(element);" *ngIf="element.epod">
                                        <img style="width: 16px;position: relative;top: 3px;" src="assets/delete.svg"
                                            [ngClass]="{action: showStatusTab==0, actionComp: showStatusTab==1}" alt="">
                                        {{'DASHBOARD.deleteEpod' | translate}}
                                    </button>
                                    <!-- <button mat-menu-item [matMenuTriggerFor]="rejection"> Rejection</button> -->
                                </mat-menu>
                                <!-- <mat-menu #rejection="matMenu">
                                    <button mat-menu-item [matMenuTriggerFor]="rejectionBoxDamages">Damage</button>

                                    <button mat-menu-item [matMenuTriggerFor]="rejectionBoxShortage">Shortages</button>
                                </mat-menu>
                                <mat-menu #rejectionBoxDamages="matMenu">
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('master Carton','damages',element)">Master
                                        Carton</button>
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('mono Box','damages',element)">Mono Box</button>
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('product Box','damages',element)">Product
                                        Box</button>
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('garment Box','damages',element)">Garment
                                        Box</button>
                                </mat-menu>
                                <mat-menu #rejectionBoxShortage="matMenu">
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('master Carton','shortage',element)">Master
                                        Carton</button>
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('mono Box','shortage',element)">Mono Box</button>
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('product Box','shortage',element)">Product
                                        Box</button>
                                    <button mat-menu-item
                                        (click)="openRejectionDialog('garment Box','shortage',element)">Garment
                                        Box</button>
                                </mat-menu> -->
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"
                            style="font-weight: bold !important; height: 50px"></tr>
                        <tr mat-row [@rowsAnimation]="" [ngClass]="{'highlightRows': selectedStatus.is_deleted == true, 'highlightRow':row._id == selectedOrderData._id,
                            'disabledRow': row.is_disabled === true}"
                            (click)="selectedStatus.is_deleted == false ? viewOrderDetails(row) : ''"
                            *matRowDef="let row; columns: displayedColumns;let i=index;"
                            style="font-family: 'Muli', sans-serif;">
                        </tr>
                    </table>
                </div>
                <div class="footer">
                    <mat-paginator [length]="(dataSource)? totalOrders:0" [showFirstLastButtons]="true" [pageSize]="25"
                        style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"
                        [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageNavigate($event)"></mat-paginator>
                </div>

            </div>


            <div class="statusTab" *ngIf="showStatusTab==1">
                <i class="material-icons" (click)="showStatusTab=0; tab=0;">clear</i>
                <div class="statusHeader">
                    <mat-grid-list cols="1" rowHeight="3:1">
                        <mat-grid-tile [ngClass]="{'selected' : tabIndex==0}" (click)="tabIndex = 0;">
                            <span>{{'DASHBOARD.allocationStatus' | translate}}</span>
                        </mat-grid-tile>
                    </mat-grid-list>
                </div>
                <div class="statusBody" *ngIf="tabIndex == 0">
                    <div style="display: flex;flex-direction: column;">
                        <div class="inputSection">
                            <div class="label">
                                Service Providers
                            </div>
                            <mat-select class="inputSelect" [(ngModel)]="selectedProviders">
                                <mat-option *ngFor="let provider of service_providers" [value]="provider">
                                    {{provider}}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div class="submitButton" style="align-self: flex-end;margin:10px 20px 4px 0px">
                            <div class="button" (click)="allocateToServiceProvider();">
                                {{'DASHBOARD.allocate' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="showLoader" class="loader">
                <div class="load">
                    <mat-spinner></mat-spinner>
                </div>

            </div>
            <ng-template #noOrders>
                <div class="noOrders" style="padding-top: 30px;">
                    {{'DASHBOARD.noOrdersFound' | translate}}
                </div>
            </ng-template>

            <ng-template #cancelDialog>
                <div class="header">
                    {{dialogData.name}}
                    <i class="material-icons">clear</i>
                </div>
                <div class="section">
                    <h2>{{dialogData.text}}</h2>
                    <div class="submitButton">
                        <div class="button">
                            {{'DASHBOARD.yes' | translate}}
                        </div>
                    </div>
                    <div class="submitButton" style="float: right;margin-right: 10px;">
                        <div class="button">
                            {{'DASHBOARD.no' | translate}}
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>

<ng-template #filtersDialog>
    <div class="Report_dialog">
        <div class="header">
            <i class="material-icons" (click)="filtersDialogRef.close()">clear</i>
        </div>
        <div class="section">
            <div class="filter_container">
                <div class="left_sec">
                    <div class="input_select">
                        <input type="text" placeholder="Invoice Number"
                            (change)="addAdvanceFilter($event.target.value, 'invoice')"
                            [value]="dashboardFilters.invoice_no || ''">
                    </div>
                </div>
                <div class="left_sec">
                    <div class="input_select">
                        <input type="text" placeholder="AWB Number"
                            (change)="addAdvanceFilter($event.target.value, 'awb')"
                            [value]="dashboardFilters.ref_number || ''">
                    </div>
                </div>

                <div class="left_sec">
                    <div class="input_select">
                        <input type="text" class="inputField" placeholder="Pickup Date From"
                            [(ngModel)]="vehicleFromDate" (click)="fromDateInput1.open()"
                            [matDatepicker]="fromDateInput1" />
                        <mat-datepicker #fromDateInput1></mat-datepicker>
                        <span class="calendaricon">
                            <img src="assets/calender-icon.svg" alt="Calender"> </span>
                    </div>
                </div>
                <div class="left_sec">
                    <div class="input_select">
                        <input type="text" class="inputField" placeholder="Pickup Date To" [(ngModel)]="vehicleToDate"
                            (click)="toDateInput1.open()" [matDatepicker]="toDateInput1" />
                        <mat-datepicker #toDateInput1></mat-datepicker>
                        <span class="calendaricon">
                            <img src="assets/calender-icon.svg" alt="Calender"> </span>
                    </div>
                </div>
                <div class="left_sec">
                    <mat-select class="inputSelect" placeholder="Order Status" style="color: #fff;border: solid 1px #DFE3EB;
              padding: 11px;font-size: 13px;">
                        <mat-option *ngFor="let status of orderStatus" [value]="status"
                            (click)="addAdvanceFilter(status, 'status')">
                            {{status}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="left_sec">
                    <mat-select class="inputSelect" placeholder="Epod State" style="color: #fff;border: solid 1px #DFE3EB;
              padding: 11px;font-size: 13px;">
                        <mat-option
                            *ngFor="let provider of ['Present', 'Not Present', 'Verified', 'Partially Verified', 'Rejected','Verification Pending']"
                            [value]="provider" (click)="addAdvanceFilter(provider, 'epod')">
                            {{provider}}
                        </mat-option>
                    </mat-select>
                </div>

            </div>
        </div>
        <div class="buttons">
            <div class="clear_btn" (click)="clear()">Clear Filter</div>
            <div class="submit_btn" (click)="submitSearch()">Search</div>
        </div>
    </div>
</ng-template>

<ng-template #viewEpod>

    <div class="dialogMissedEvent">
        <div class="dialog_header">
            <div class="dialog_title">View Epods</div>
            <div class="close">
                <i class="material-icons" (click)="previewRef.close()" style="color: #000; cursor: pointer;">clear</i>
            </div>
        </div>
        <div class="dialog_body">
            <div class="prev" *ngIf="epod">
                <img [src]="epod" style=" height: 400px; width: 600px; ">
            </div>
        </div>
    </div>
</ng-template>


<ng-template #uploadDocs>
    <div class="uploadDialogMain">
        <div class="header">
            <div class="label">
                {{'DASHBOARD.upload_epod' | translate}}
            </div>
            <div class="close">
                <span class="material-icons" (click)="uploadDocsRef.close()" style="cursor: pointer;">
                    close
                </span>
            </div>
        </div>
        <div class="body">
            <div class="question">
                <!-- <input type="file" multiple (change)="fileChanged($event)"> -->
                <div class="filters_sec">
                    <div class="filter">
                        <div class="label">{{'DASHBOARD.epod_date' | translate}}</div>
                        <div class="input">
                            <input type="text" class="inputField" placeholder="Date" [(ngModel)]="epod_date"
                                (click)="epodDateInput.open()" [matDatepicker]="epodDateInput" />
                            <mat-datepicker #epodDateInput>
                            </mat-datepicker>
                            <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
                        </div>
                    </div>
                    <div class="filter">
                        <div class="label">{{'DASHBOARD.delivery_date' | translate}}</div>
                        <div class="input">
                            <input type="text" class="inputField" placeholder="Date" [(ngModel)]="delivery_date"
                                (click)="deliveryDateInput.open()" [matDatepicker]="deliveryDateInput" />
                            <mat-datepicker #deliveryDateInput>
                            </mat-datepicker>
                            <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
                        </div>
                    </div>
                </div>
                <div class="upload_file_sec">
                    <input type="file" #fileUploader (change)="fileChanged($event, 'epod')"
                        accept="image/gif, image/jpeg, image/png, application/pdf" name="csv" id="csv">
                </div>

            </div>
            <div class="buttons">
                <div class="submitButton" style="background-color: #824570;" (click)="UploadEpod();">
                    <div class="button">
                        {{'DASHBOARD.submit' | translate}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #reportDialog>
    <div class="Report_dialog">
        <div class="header">
            <i class="material-icons" (click)="reportDialogRef.close()">clear</i>
        </div>
        <div class="section">
            <div class="filter_container">


                <div class="left_sec">
                    <div class="input_select">
                        <input type="text" class="inputField" placeholder="Pickup Date From"
                            [(ngModel)]="reportFromDate" (click)="fromDateInput2.open()"
                            [matDatepicker]="fromDateInput2" />
                        <mat-datepicker #fromDateInput2></mat-datepicker>
                        <span class="calendaricon">
                            <img src="assets/calender-icon.svg" alt="Calender"> </span>
                    </div>
                </div>
                <div class="left_sec">
                    <div class="input_select">
                        <input type="text" class="inputField" placeholder="Pickup Date To" [(ngModel)]="reportToDate"
                            (click)="toDateInput2.open()" [matDatepicker]="toDateInput2" />
                        <mat-datepicker #toDateInput2></mat-datepicker>
                        <span class="calendaricon">
                            <img src="assets/calender-icon.svg" alt="Calender"> </span>
                    </div>
                </div>
                <div class="left_sec">
                    <mat-select class="inputSelect" placeholder="Order Status" style="color: #fff;border: solid 1px #DFE3EB;
              padding: 11px;font-size: 13px;" [(ngModel)]="selectedDeliveryStatus">
                        <mat-option *ngFor="let status of orderStatus" [value]="status">
                            {{status}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="left_sec">
                    <mat-select class="inputSelect" placeholder="Service Provider" style="color: #fff;border: solid 1px #DFE3EB;
            padding: 11px;font-size: 13px;color: #131722;" [(ngModel)]="selectedServiceProvider">
                        <mat-option *ngFor="let provider of service_providers" [value]="provider">
                            {{provider}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="left_sec">
                    <mat-select class="inputSelect" placeholder="Epod State" style="color: #fff;border: solid 1px #DFE3EB;
              padding: 11px;font-size: 13px;" [(ngModel)]="selectedEpodStatus">
                        <mat-option
                            *ngFor="let provider of ['Present','Not Present','Verified','Rejected','Verification Pending']"
                            [value]="provider">
                            {{provider}}
                        </mat-option>
                    </mat-select>
                </div>

            </div>
        </div>
        <div class="buttons">
            <div class="clear_btn" (click)="clearReportDialog()">Clear</div>
            <div class="submit_btn" (click)="generateReport()">Download</div>
        </div>
    </div>
</ng-template>